export default __webpack_public_path__ + "static/media/khelghar-flat.105e27de.jpg";